import { Vue, Component, Watch } from "vue-property-decorator";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { GuestbookLabels } from "@/enums/GuestbookLabels";
import { Resident } from "@/models/resident/Resident";
import { Guestbook } from "@/models/guestbook/Guestbook";
import { GuestbookRules } from "@/models/guestbook/GuestbookRules";
import CreateVisit from "@/views/guestbook/dialogs/create-visit/CreateVisit.vue";
import { PeriodEnum } from "@/enums/PeriodEnum";
import moment from "moment";
import {toTranslationKey} from "@/utils/stringFormat";

@Component({
  components: {
    CreateVisit
  }
})
export default class GuestbookList extends Vue {
  ready = false;
  filteredVisitTypes = [];
  valid = true;
  today = null;
  focus = "";
  type = "week";
  typeToLabel = GuestbookLabels;
  typeToLabels = Object.values(GuestbookLabels).map(x => ({ text: x, value: x }))
  start = null;
  end = null;
  weekdays = [];

  $refs!: {
    guestbook: HTMLFormElement;
    modalCreateVisit: HTMLFormElement;
  };

  get facility() {
    return this.$store.state.facilityModule.selectedFacility;
  }

  get guestbook(): Guestbook[] {
    return this.$store.state.guestbookModule.guestbook;
  }

  get residents(): Resident[] {
    return this.$store.state.residentModule.residentsShortData;
  }

  get guestbookRules(): GuestbookRules {
    return this.$store.state.guestbookModule.guestbookRules;
  }

  get gb() {
    return this.ready ? this.$refs?.guestbook : false;
  }

  get nowY() {
    return this.gb
      ? this.gb.timeToY(
          this.guestbookRules == null ? 0 : this.guestbookRules.start
        ) + "px"
      : "-10px";
  }

  get nowEnd() {
    return this.gb
      ? this.gb.timeToY(
          this.guestbookRules == null ? 0 : this.guestbookRules.end
        ) + "px"
      : "-10px";
  }

  get lunchStart() {
    return this.gb
      ? this.gb.timeToY(
          this.guestbookRules == null ? 0 : this.guestbookRules.lunchStart
        ) + "px"
      : "-10px";
  }

  get title(): string {
    const { start, end } = this;
    if (!start || !end) {
      return "";
    }
    const startMonth = this.monthFormatter(start);
    const startYear = start.year;
    const startDay = start.day + GuestbookList.nth(start.day);
      
    switch (this.type.charAt(0).toUpperCase()) {
      case PeriodEnum.Week:
      case PeriodEnum.Day:
        return `${startMonth} ${startDay} ${startYear}`;
    }
    return "";
  }

  get monthFormatter() {
    return this.$refs.guestbook.getFormatter({
      timeZone: "UTC",
      month: "long",
    });
  }

  get getCategories() {
    return this.guestbookRules.visitTypes?this.guestbookRules.visitTypes.map(a => a.name):[];
  }

  get dateTitle(){
    return this.$refs.guestbook.title//moment(this.$refs.guestbook.title).locale(this.$i18n.locale).format('MMM YYYY') 
  }

  get events2() {
    const events = [];
    for (let i = 0; i < this.guestbook.length; i++) {
      const dbEvt = this.guestbook[i];
      events.push({
        name: dbEvt.residentName + " | " + dbEvt.visitors.length + this.$i18n.messages[this.$i18n.locale]['GuestbookList.Visitors'],
        category: dbEvt.visitType,
        id: dbEvt.id,
        visitors: dbEvt.visitors,
        start: moment(dbEvt.start).format('YYYY-MM-DD HH:mm'),
        end: moment(dbEvt.end).format('YYYY-MM-DD HH:mm'),
        color: GuestbookList.getColor(dbEvt.type)
      });

    }
    return events;
  }

  private static nth(d) {
    return d > 3 && d < 21
      ? "th"
      : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
  }

  private static getColor(type): string {
    if (type == "social") return "green";
    else if (type == "familyVisit") return "indigo";
    else if (type == "notice") return "red";
    else if (type == "medical") return "pink";
    else if (type == "concierge") return "orange";
    return "green";
  }

  @Watch("events2")
  events2Watch() {
    this.$forceUpdate();
    this.scrollToTime();
    this.$refs.guestbook.updateTimes();
  }

  created() {
    this.$store.dispatch("getGuestbook");
    this.$store.dispatch("getGuestbookRules");
  }

  mounted() {
    this.ready = true;

    if(this.guestbookRules.lunchStart) {
      this.guestbookRules.lunchStart = this.guestbookRules.lunchStart.seconds ? moment(this.guestbookRules.lunchStart?.seconds * 1000).format("HH:mm") : this.guestbookRules.lunchStart;
    }

    if(this.guestbookRules.lunchEnd) {
      this.guestbookRules.lunchEnd = this.guestbookRules.lunchEnd.seconds ? moment(this.guestbookRules.lunchEnd?.seconds * 1000).format("HH:mm") : this.guestbookRules.lunchEnd;
    }

    this.scrollToTime();
    this.allowsDays()
  }

  convertToTranslationKey(text: string){
    return toTranslationKey(text)
  }
  
  intervalFormatter(locale, getOptions) {
    const format = this.facility.timeFormat.split(' ')[1] || ''
    const timeFormatted = moment(locale.time, ["HH:mm"]).format(`${format == 'A'?'h':'H'}${format?' '+ format:''}`)
    return timeFormatted;
  }

  allowsDays() {
    if(Object.prototype.hasOwnProperty.call(this.guestbookRules, 'monday')) {
      if(this.guestbookRules?.monday){
        this.weekdays.push(1)
      }
      if(this.guestbookRules?.tuesday){
        this.weekdays.push(2)
      }
      if(this.guestbookRules?.wednesday){
        this.weekdays.push(3)
      }
      if(this.guestbookRules?.thursday) {
        this.weekdays.push(4)
      }
      if(this.guestbookRules?.friday) {
        this.weekdays.push(5)
      }
      if(this.guestbookRules?.saturday) {
        this.weekdays.push(6)
      }
      if(this.guestbookRules?.sunday) {
        this.weekdays.push(0)
      }
    } else {
      this.weekdays = [0,1,2,3,4,5,6]
    }
  }

  viewDay({ date }): void {
    this.focus = date;
    this.type = "day";
  }

  setToday(): void {
    this.focus = this.today;
  }

  prev(): void {
    this.$refs.guestbook.prev();
  }

  next(): void {
    this.$refs.guestbook.next();
  }

  showVisit({ event }): void {
    this.$router.push("/guestbook/" + event.id.toString());
  }

  createVisit(data){
    const date = data.date;
    const start = moment(`${data.hour}`, 'h:mma').format('HH:mm');
    (this.$refs.modalCreateVisit as any).open(date, start)
  }

  private getCurrentTime() {
    return this.guestbookRules == null ? 0 : this.guestbookRules.start * 60;
  }

  private scrollToTime(): void {
    const time = this.getCurrentTime();
    const first = Math.max(0, time - (time % 30) - 30);
    this.$refs.guestbook.scrollToTime(first);
  }
}
